import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import type from './types';
import { toastr } from 'react-redux-toastr';

const URL = `${BASE_API}/journeys`;

export const buscarJornadas = () => {
  return () =>
    axios
      .get(`${URL}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => response.data);
};

export const getJourneys = () => {
  return (dispatch) => {
    dispatch([
      {
        type: type.LIST_LOAD,
        payload: true,
      },
    ]);
    axios
      .get(`${URL}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: type.LIST_FETCHED,
            payload: response,
          },
        ]);
      })
      .catch((e) => {
        try {
          toastr.error(e.response.data.messages[0], 'Erro');
        } catch {
          toastr.error('Erro');
        }
        dispatch([
          {
            type: type.LIST_ERROR,
            payload: true,
          },
        ]);
      });
  };
};

export const getJourneyRanking = (journeyId) => {
  return (dispatch) => {
    dispatch([
      {
        type: type.RANKING_FETCHED,
        payload: { data: null },
      },
      {
        type: type.RANKING_LOAD,
        payload: true,
      },
    ]);
    axios
      .get(`${URL}/${journeyId}/ranking`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: type.RANKING_FETCHED,
            payload: response,
          },
        ]);
      })
      .catch((e) => {
        try {
          toastr.error(e.response.data.messages[0], 'Erro');
        } catch {
          toastr.error('Erro', 'Não foi possível carregar o ranking');
        }
        dispatch([
          {
            type: type.RANKING_ERROR,
            payload: true,
          },
        ]);
      });
  };
};
